import { BaseApi } from 'src/api/BaseApi';
import { DEMO_EXPERTS } from 'src/api/demo/experts';

class DraftApi extends BaseApi {
  async find2Experts(queryID) {
    if (this.isDemo()) {
      // Return 2 random experts from the demo data in the expected format
      const activeExperts = DEMO_EXPERTS.filter((expert) => expert.isActive === 1);
      const shuffled = [...activeExperts].sort(() => 0.5 - Math.random());
      const twoExperts = shuffled.slice(0, 2);
      // Return comma-separated expert IDs to match API format
      return twoExperts.map((e) => e.id).join(',');
    }

    const formData = this.createFormData({
      queryID,
      override: 1,
    });

    const response = await this.postRequest('experts/findexperts', formData);
    return response.data;
  }

  async generateInitialEmail(queryID, expertID) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        queryID,
        expertID,
        email: {
          subject: 'Demo Mode: Media Opportunity',
          body: 'This is a demo email generated in demo mode. In production, this would contain a personalized pitch based on the query and expert information.',
        },
      });
    }

    const formData = this.createFormData({
      queryID,
      expertID,
    });

    const response = await this.postRequest('queries/generate/initialemail', formData);
    return response.data;
  }
}

export const draftApi = new DraftApi();

